import { setDetailGood } from '../../action';
import { identityPayload, createReducer, forAction } from '../../utils';

const initialState = null;

export default createReducer(
  [forAction(setDetailGood, identityPayload)],
  initialState,
);
